// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { promotionCodeFormStyles } from "@tps/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import { css } from "styled-components";

promotionCodeFormStyles.form = {
    css: css`
        position: relative;
    `,
};
promotionCodeFormStyles.promotionCodeTextField = {
    cssOverrides: {
        formInputWrapper: css`
            &&&input {
                padding-right: 80px;
            }
        `,
    },
};
promotionCodeFormStyles.applyButton = {
    css: css`
        min-height: 28px;
        height: 28px;
        width: 72px;
        padding: 6px;
        display: flex;
        position: absolute;
        right: 3px;
        top: 29px;
        ${TypographyStyle} {
            font-size: 11px;
            line-height: 15px;
        }
    `,
};

promotionCodeFormStyles.gridContainer = { gap: 0 };

promotionCodeFormStyles.promotionCodeGridItem = {
    width: 12,
    css: css`
        margin-top: 10px;
    `,
};

promotionCodeFormStyles.applyPromotionGridItem = {
    width: 0,
    css: css`
        display: inline;
    `,
};

promotionCodeFormStyles.removeCodesGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        &&& {
            margin: 8px 0;
        }
    `,
};

promotionCodeFormStyles.removeCodeTag = {};

promotionCodeFormStyles.applySuccessText = {
    color: "success",
    size: 14,
};

promotionCodeFormStyles.promotionRemovedGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        &&& {
            margin-top: 8px;
        }
    `,
};

promotionCodeFormStyles.promotionAppliedGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        &&& {
            margin-top: 8px;
        }
    `,
};

promotionCodeFormStyles.promotionRemovedText = {
    size: 14,
};

promotionCodeFormStyles.applySuccessText = {
    color: "success",
    size: 14,
};
